import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {OphFormFieldModule} from '../../shared/design/oph-form-field/oph-form-field.module';
import {OphButtonModule} from '../../shared/design/oph-button/oph-button.module';
import {WikiGroupDialogComponent, WikiGroupDialogData} from '../wiki-group-dialog/wiki-group-dialog.component';
import {WIKI_GROUP_DIALOG_SETTINGS} from '../shared/wiki.constants';
import {WikiGroup} from './../models/wiki.model';
import {MatIconModule} from '@angular/material/icon';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'wiki-toolbar',
  standalone: true,
  imports: [OphButtonModule, OphFormFieldModule, MatIconModule],
  templateUrl: './wiki-toolbar.component.html',
  styleUrl: './wiki-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiToolbarComponent {
  private readonly mobileService = inject(MobileService);
  @Input() wikiGroups: WikiGroup[] = [];
  readonly dialog = inject(MatDialog);

  onCreateWikiGroup(): void {
    this.dialog.open(WikiGroupDialogComponent, {
      data: {group: null, groups: this.wikiGroups} as WikiGroupDialogData,
      ...WIKI_GROUP_DIALOG_SETTINGS,
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
    });
  }
}
